import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  LoaderSize,
  LoaderThemeColor,
  LoaderType,
} from '@progress/kendo-angular-indicators';

@Component({
  selector: 'app-internal-link',
  templateUrl: './internal-link.component.html',
  styleUrls: ['./internal-link.component.scss'],
})
export class InternalLinkComponent {
  @Input() text: string;
  @Input() pageUrl: string;
  @Input() clickEvent: () => Promise<unknown>;
  selected = false;
  loader = {
    type: <LoaderType>'converging-spinner',
    themeColor: <LoaderThemeColor>'primary',
    size: <LoaderSize>'small',
  };

  constructor(private router: Router) {}

  async submit() {
    this.selected = true;
    if (this.clickEvent !== undefined) await this.clickEvent();
    this.router.navigate([this.pageUrl], {});
  }
}
